var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNmbr3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 76,
    viewBox: "0 0 95 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 37.6914C69 55.0884 54.897 69.1914 37.5 69.1914C20.103 69.1914 6 55.0884 6 37.6914C6 20.2944 20.103 6.19141 37.5 6.19141C54.897 6.19141 69 20.2944 69 37.6914Z",
    fill: "white",
    stroke: "#2C4245",
    strokeWidth: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1819 33.0074H33.5659C33.7259 31.5354 34.6539 30.1274 36.8299 30.1274C38.8779 30.1274 39.9979 31.2154 39.9979 33.0394C39.9979 35.3434 38.0779 36.0794 35.4539 36.0794H34.5259V39.7594H35.4539C38.7819 39.7594 40.4459 40.7194 40.4459 43.3434C40.4459 45.1994 39.2939 46.6074 37.0539 46.6074C34.6539 46.6074 33.3099 45.1674 33.2139 43.1514H28.8619C29.0539 48.0474 32.5419 50.3514 37.1499 50.3514C42.0459 50.3514 44.7339 47.5354 44.7339 43.7274C44.7339 40.5594 43.1659 38.6394 40.7979 37.9034V37.7754C42.4939 37.1994 44.3179 35.4074 44.3179 32.4954C44.3179 29.0394 41.7579 26.3194 36.9579 26.3194C32.4779 26.3194 29.4059 28.6874 29.1819 33.0074Z",
    fill: "#32474A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92 36.4594C93.3333 37.2292 93.3333 39.1537 92 39.9235L72.5 51.1818C71.1667 51.9516 69.5 50.9893 69.5 49.4497L69.5 26.9331C69.5 25.3935 71.1667 24.4312 72.5 25.201L92 36.4594Z",
    fill: "#2C4245"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmbr3);
export default __webpack_public_path__ + "static/media/nmbr3.bacf3874f60c5d46b875a853100ad778.svg";
export { ForwardRef as ReactComponent };